import styled from 'styled-components';
import React from 'react';
import { palette } from '@dev/ee-components';
import { Search } from './components/Search';
import { MobileFilters } from './components/MobileFilters';


const Header = styled.div`
    display: flex;
    margin-bottom: 20px;
    margin-top: 32px;
    justify-content: space-between;
`;
const FiltersContainer = styled.div`
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid ${palette.gray[3]};
    margin-left: 8px;
    padding: 11px 11px;
`;
const SearchContainer = styled.div`
    width: 100%;
    & > div {
        border: 1px solid ${palette.gray[3]};
    }
`;

export const MobileTableFilters = (): JSX.Element => (
    <Header>
        <SearchContainer>
            <Search />
        </SearchContainer>
        <FiltersContainer>
            <MobileFilters />
        </FiltersContainer>
    </Header>
);
